/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Avatar } from '@coursera/cds-core';
import { UserIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/ai-coach-platform';

type Props = {
  imageUrl?: string;
};

const LearnerAvatar = ({ imageUrl }: Props) => {
  if (!imageUrl) {
    return (
      <div
        css={css`
          height: 32px;
          width: 32px;
          border-radius: 50%;
          background-color: var(--cds-color-blue-950);
          display: flex;
          align-items: center;
          justify-content: center;

          svg {
            color: var(--cds-color-white-0);
          }
        `}
        data-testid="fallback-avatar"
      >
        <UserIcon size="medium" />
      </div>
    );
  }

  return (
    <Avatar
      aria-label={_t('Learner avatar')}
      aria-hidden
      variant="user"
      showBorder={false}
      imgProps={{
        src: imageUrl,
      }}
      css={css`
        flex-shrink: 0;
        width: 32px !important;
        height: 32px !important;
      `}
    />
  );
};

export default LearnerAvatar;
